<template>
  <div class="Resume container">
    <div class="tile is-ancestor">

      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ $t('resume.experience') }}</p>
          <p class="subtitle">{{ $t('resume.in_years') }}</p>
          <SkillTech
            v-for="(skill, key) in skills"
            v-bind:key="key"
            :score="skill.score" :skill="skill.name" :year="skill.years"></SkillTech>
        </article>
      </div>

      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ $t('resume.skills') }}</p>
          <p class="subtitle">{{ $t('resume.tech_stack') }}</p>
          <SkillWork
            v-for="(work, key) in works"
            v-bind:key="key"
            :work="work"/>
        </article>
      </div>

      <div class="tile is-parent">
        <article class="tile is-child box">
          <p class="title">{{ $t('resume.certification') }}</p>
          <p class="subtitle">{{ $t('resume.cources') }}</p>
          <SkillTech />
        </article>
      </div>

    </div>
  </div>
</template>

<script>
import SkillTech from '@/components/resume/SkillTech'
import SkillWork from '@/components/resume/SkillWork'
import SkillsJson from '../assets/json/skills.json';

export default {
  name: "Resume",

  components: {
    SkillTech,
    SkillWork
  },

  data() {
    return {
      skills: SkillsJson.tech,
      works: SkillsJson.work
    }
  },
}
</script>

<style lang="scss">
.Resume {
  margin-top: 4em !important;

  .box {
    background-color: $background;
    box-shadow: none;
  }
}
</style>
